module.exports = __webpack_public_path__ + "static/media/trustbox.331fd06a.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/images/trustbox.png
// module id = 1423
// module chunks = 0